import React, { useState } from "react";
import ImageBackground from '../../Assets/Images/background-contnt.png'
import { t } from "i18next";
import '../../Assets/Styles/Customer/customer-info.css';
import '../../Assets/Styles/Payment/payment-request.css';
import CustomNav from "../../Components/custom-nav/CustomNav";
import PaymentApplication from "./payment-application";
import useWindowDimensions from "../../Layouts/useWindowDimension";
import { RadioGroup } from "@mui/material";
import CustomRadio from "../../Components/custom-radio/CustomRadio";
import * as PosService from '../../Services/pos-service';
import * as ClaimService from '../../Services/claim-service';
import PaymentPolicyInfo from "./payment-policy-info";
import { useNavigate } from "react-router-dom";
import { CustomAutocomplete } from "../../Components/custom-combobox/CustomAutocomplete";
import { countTimeExpired } from "../../Services/service";
import FooterCustomer from '../../Layouts/footer/FooterCustomer';

const PaymentRequest = () => {
    const [objectLocal, setObjectLocal] = useState(JSON.parse(localStorage.getItem('aaa')));
    const [objectDto, setObjectDto] = useState(sessionStorage.getItem("objectDto") !== null && sessionStorage.getItem("objectDto") !== "undefined" ?
        JSON.parse(sessionStorage.getItem("objectDto")) : { "checked": 0, "policyChecked": 0 });
    const [activeItem, setActiveItem] = useState({ title: t("onlinepaymentcustomer"), icon: <i class="fa fa-database" aria-hidden="true"></i>, no: 2 });
    const { height, width } = useWindowDimensions();
    const [listPo, setListPo] = useState([]);
    const [policyNo, setPolicyNo] = useState('');
    if (listPo.length === 0) ClaimService.getListPolicyNumber(setListPo, setObjectDto);
    const navigation = useNavigate();
    countTimeExpired(objectDto, setObjectDto);
    if (listPo === 401) navigation('/')
    const divStyle = {
        backgroundImage: `url(${ImageBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100vw',
        height: height,
        backgroundRepeat: 'no-repeat'
    };
    function onValueRadioChange(event) {
        if (event.target.value === "1") {
            setObjectDto({ ...objectDto, paymentType: 1 });
        } else if (event.target.value === "0") {
            setObjectDto({ ...objectDto, paymentType: 0 });
        }
    }

    return (
        <>
            <div className='nav-container' style={{ height: height }}>
                <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectLocal} setObjectDto={setObjectLocal} width={width} height={height} />
                <div className="payment-request-background" style={divStyle}>
                    {
                        objectDto !== undefined && objectDto !== null && objectDto !== '' && !_.isEmpty(objectDto) ?
                            <section className="payment-request-container" >
                                <div>
                                    <div className="col-sm-12 col-xs-12 col-md-12 " style={{ textAlign: "-webkit-center", textAlign: "-moz-center" }}>
                                        <label className="title-head-claim header-title-customer" style={{ textAlign: "center" }}>{t("paymenttitle").toUpperCase()}</label>
                                    </div>
                                </div>
                                <div style={{ padding: "0 0 12% 0" }}>
                                    <div className="col-sm-12 col-xs-12 col-md-12 btn-payment-type">
                                        {
                                            objectDto.checked === 0 ?
                                                <RadioGroup value={objectDto.paymentType == 1 ? 1 : objectDto.paymentType == 0 ? 0 : null} row={true} onChange={onValueRadioChange} className="col-md-12">
                                                    <div className="col-sm-6 col-xs-6 col-md-6 btn-payment-type-LA-info" style={{ "textAlign": "end" }}>
                                                        <CustomRadio title={t("paymentpolicyterm")} value={1} id="yes" className="iCheck-radio" />
                                                    </div>
                                                    <div className="col-sm-6 col-xs-6 col-md-6 btn-payment-type-PO-info" style={{ "textAlign": "start" }}>
                                                        <CustomRadio title={t("paymentapplication")} value={0} id="yes" className="iCheck-radio" />
                                                    </div>
                                                </RadioGroup>
                                                :
                                                <RadioGroup value={objectDto.paymentType ? 1 : 0} row={true} onChange={onValueRadioChange} className="col-md-12">
                                                    {
                                                        objectDto.paymentType === 1 ?
                                                            <div className="col-sm-12 col-xs-12 col-md-12 btn-payment-type-LA-info" style={{ "textAlign": "center" }}>
                                                                <CustomRadio disabled={true} title={t("paymentpolicyterm")} value={1} id="yes" className="iCheck-radio" />
                                                            </div>
                                                            :
                                                            <div className="col-sm-12 col-xs-12 col-md-12 btn-payment-type-PO-info" style={{ "textAlign": "center" }}>
                                                                <CustomRadio disabled={true} title={t("paymentapplication")} value={0} id="yes" className="iCheck-radio" />
                                                            </div>
                                                    }
                                                </RadioGroup>
                                        }
                                    </div>
                                </div>
                                {
                                    objectDto.paymentType === 1 ?
                                        <div>
                                            <div data-toggle="collapse" data-target="#content-box-0" className="header-box">
                                                <h2 className="title-box">{objectDto.checked === 0 ? t("paymentpolicycheck").toUpperCase() : t("paymentinfo").toUpperCase()}</h2>
                                            </div>

                                            <div className="collapse in" id="content-box-0">
                                                <div className="border-box-sc row">
                                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                        <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                                            {
                                                                objectDto.checked === 0 ?
                                                                    <fieldset className="agent-information">
                                                                        <div className="col-md-12 form-group">
                                                                            <label className="col-md-4 required">{t("policynumber")}</label>
                                                                            <div className="col-md-8">
                                                                                <CustomAutocomplete placeholder={"Danh sách hợp đồng"} value={policyNo} data={listPo}
                                                                                    handleChange={(e) => PosService.handleChangeEventTextContent(e, setPolicyNo)}
                                                                                />
                                                                            </div>
                                                                            <div className="footer-box-bg mt-10">
                                                                                <a id="btnCheck" className="btn-common btn-search" onClick={() => {
                                                                                    setObjectDto({ ...objectDto, checked: 1 });
                                                                                    objectDto.checked = 1;
                                                                                }}>
                                                                                    <i className=" fa fa-search" />{" "} <span>{t("buttoncheck")}</span>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </fieldset>
                                                                    : objectDto.checked === 1 ?
                                                                        <fieldset className="agent-information">
                                                                            <div className="form-group col-md-12">
                                                                                <label className="col-md-2">
                                                                                    {t("policynum")}
                                                                                </label>
                                                                                <div className="col-md-4">
                                                                                    <label className="form-control form-detail">{objectDto.poNumber}</label>
                                                                                </div>
                                                                                <label className="col-md-2">
                                                                                    {t("idnumber")}
                                                                                </label>
                                                                                <div className="col-md-4">
                                                                                    <label className="form-control form-detail">{objectDto.poIdNumber}</label>
                                                                                </div>
                                                                            </div>
                                                                        </fieldset>
                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    objectDto.checked === 1 ? <PaymentPolicyInfo /> : ""
                                                }
                                            </div>
                                        </div>
                                        :
                                        ""
                                }
                                {
                                    objectDto.paymentType === 0 && objectDto.checked === 0 ?
                                        <div>
                                            <PaymentApplication />
                                        </div>
                                        :
                                        ""
                                }
                            </section>
                            :
                            <div style={{ textAlign: "center", paddingTop: "120px" }}>
                                <h3 style={{ color: "red", fontWeight: "bold" }}>{t("erroraccesspage").toUpperCase() + " "}<a style={{ "color": "#c4960c" }} href="/" >Về trang chủ</a></h3>
                                <CircularProgress style={{ color: "red", marginTop: "50px" }} />
                            </div>
                    }
                </div >
            </div >
            <FooterCustomer />
        </>
    )
};

export default PaymentRequest;